import { useEffect, useRef, useState } from 'react';
import { POLL_INTERVAL_MS, POLL_TIMEOUT_MS } from '../config';

/**
 * Pollt eine URL in regelmäßigen Abständen.
 *
 * @param {string|null} url        - Zu pollende URL (null = pausiert)
 * @param {function}    condition  - Gibt true zurück wenn Ergebnis vorliegt
 * @returns {{ data, error, timedOut }}
 */
export function usePolling(url, condition) {
  const [data, setData]       = useState(null);
  const [error, setError]     = useState(null);
  const [timedOut, setTimedOut] = useState(false);
  const timerRef  = useRef(null);
  const startRef  = useRef(null);

  useEffect(() => {
    if (!url) return;

    startRef.current = Date.now();

    const poll = async () => {
      if (Date.now() - startRef.current > POLL_TIMEOUT_MS) {
        clearInterval(timerRef.current);
        setTimedOut(true);
        return;
      }

      try {
        const res = await fetch(url);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();

        if (condition(json)) {
          clearInterval(timerRef.current);
          setData(json);
        }
      } catch (err) {
        clearInterval(timerRef.current);
        setError(err.message);
      }
    };

    poll(); // sofort beim Start
    timerRef.current = setInterval(poll, POLL_INTERVAL_MS);

    return () => clearInterval(timerRef.current);
  }, [url]); 
  return { data, error, timedOut };
}
